import { Box } from '@chakra-ui/react';
import React, {
  useEffect,
  useState,
} from 'react';

import Uppy, {} from '@uppy/core';
import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import { Dashboard } from '@uppy/react';
import useClient from 'shared/src/hooks/useClient';
import GitlUploader from './plugins/GitlUploader';
import MetadataAdder from './plugins/MetadataAdder';
import VideoThumbnail from './plugins/VideoThumbnail';


const VideoUploader = ({ onChange, businessId }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => () => {
    // on unmount, free memory
    if (url) URL.revokeObjectURL(url);
  });
  const client = useClient();

  const [uppy] = useState(
    () => {
      return new Uppy({
        autoProceed: true,
        allowMultipleUploadBatches: false,
        allowMultipleUploads: false,
        restrictions: {
          maxNumberOfFiles: 1,
          allowedFileTypes: ['.mp4'],
        },
      })
        .use(MetadataAdder, {})
        .use(VideoThumbnail, {})
        .use(GitlUploader, {
          client,
          businessId,
        })
        .on('upload-success', (file, response) => {
          const { imageRefId } = response;
          onChange(imageRefId);
          // Capture an object virtual URL for the file since we have no way of getting
          // the uploaded URL yet
          setUrl(URL.createObjectURL(file.data));
        });
    },
    [],
  );

  return (
    <Box>
      {
        url
          ? (
            <video controls src={url} />
          )
          : (
            <Dashboard
              uppy={uppy}
              doneButtonHandler={null} // hide DONE button after upload
              note="mp4 - 1080x1920"
            />
          )
      }
    </Box>
  );
};

export default VideoUploader;
